import ExcelJS from "exceljs";
import saveAs from "file-saver";
import { IDFCConfig, KOTAKConfig } from "./DownloadExcelSheet.config";
let initialState = [
  "Party_Name",
  "Account_Number",
  "Bank_IFSC_Code",
  "TypeOfPayment",
  "Debit_Account_Number",
  "Transaction_Date",
  "Amount",
  "Currency",
  "Beneficiary_Email_ID",
  "Remarks",
];

async function DownloadExcelSheet(data) {
  // Mapping datalet bank
  let Bank = data[0].Debit_Account_IFSC_Code;
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Sheet 1");
  if (Bank.includes("IDFB")) {
    initialState = IDFCConfig.IDFCFields;
    const headerRowRef = worksheet.addRow(IDFCConfig.IDFCHeaders);
    worksheet.addRow([]);
  } else if (Bank.includes("KKBK")) {
    initialState = KOTAKConfig;
  } else if (Bank.includes("SBIN")) {
  }
  let updatedData = data.map((el) => {
    let obj = { ...initialState };
    for (let element in initialState) {
      if (el[element]) {
        obj = { ...obj, [element]: el[element] };
      }
    }
    return obj;
  });
  let keyArray = [];
  for (let key in initialState) {
    keyArray.push(key);
  }

  // Adding Header Row

  // Adding a blank row after the header

  // Adding Data and setting cell format

  updatedData.forEach((item, rowNumber) => {
    let dataRow = [];
    keyArray.forEach((header, index) => {
      if (typeof item[header] === "number") {
        dataRow.push(item[header].toString()); // convert large/small number to string
      } else {
        dataRow.push(item[header]);
      }
    });
    worksheet.addRow(dataRow);
  });

  // Auto width columns
  worksheet.columns.forEach((column, i) => {
    let maxLength = 0;
    column.eachCell({ includeEmpty: true }, (cell) => {
      let columnLength = cell.text.length;
      if (columnLength > maxLength) {
        maxLength = columnLength;
      }
    });
    column.width = maxLength < 10 ? 10 : maxLength; // Minimum width 10
  });

  // Create buffer
  const buffer = await workbook.xlsx.writeBuffer();

  // Create a blob and download
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, "Data.xlsx");
}

export default DownloadExcelSheet;
